import UserProfileContext from '../../context/userprofilecontext.js';

import React, { Fragment, useContext } from 'react';
import PageSkeleton from './pageskeleton.js';

export default function CurrentUserContextRequired(props) {
    const userProfileContext = useContext(UserProfileContext);
    const userProfile = userProfileContext.userProfile;

    if (userProfileContext.isLoading || !userProfile) {
        return <PageSkeleton/>;
    }

    return <Fragment>{props.children}</Fragment>;
}